(function () {
  var SECTION_SELECTOR = '.ctr-features';

  function setActive(section, activeItem) {
    var items = section.querySelectorAll('[data-ctr-features-item]');

    items.forEach(function (item) {
      var isActive = item === activeItem;
      item.classList.toggle('is-active', isActive);

      var trigger = item.querySelector('[data-ctr-features-trigger]');
      if (trigger) {
        trigger.setAttribute('aria-expanded', isActive ? 'true' : 'false');
      }
    });
  }

  function initSection(section) {
    if (!section || section.dataset.ctrFeaturesReady === 'true') return;

    section.dataset.ctrFeaturesReady = 'true';

    var items = Array.prototype.slice.call(
      section.querySelectorAll('[data-ctr-features-item]')
    );

    if (!items.length) return;

    items.forEach(function (item) {
      var trigger = item.querySelector('[data-ctr-features-trigger]');
      if (!trigger) return;

      trigger.addEventListener('click', function () {
        setActive(section, item);
      });
    });

    var initiallyActive =
      section.querySelector('[data-ctr-features-item].is-active') || items[0];
    setActive(section, initiallyActive);
  }

  function findSection(root) {
    if (!root) return null;
    if (root.matches && root.matches(SECTION_SELECTOR)) return root;
    return root.querySelector ? root.querySelector(SECTION_SELECTOR) : null;
  }

  function initAll() {
    document.querySelectorAll(SECTION_SELECTOR).forEach(initSection);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initAll);
  } else {
    initAll();
  }

  document.addEventListener('shopify:section:load', function (event) {
    var section = findSection(event.target);
    if (!section) return;
    delete section.dataset.ctrFeaturesReady;
    initSection(section);
  });

  document.addEventListener('shopify:section:unload', function (event) {
    var section = findSection(event.target);
    if (!section) return;
    delete section.dataset.ctrFeaturesReady;
  });

  document.addEventListener('shopify:block:select', function (event) {
    var item = event.target.closest
      ? event.target.closest('[data-ctr-features-item]')
      : null;
    if (!item) return;

    var section = item.closest(SECTION_SELECTOR);
    if (!section) return;

    setActive(section, item);
  });
})();
